module.exports = __webpack_public_path__ + "static/lifting-b5c8bfeeb8b70998750b35a16815a6aa.png";